import React from "react";
import classNames from "classnames";
import { Field } from "react-final-form";
import { InputLabel, TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  root: {
    marginBottom: "20px",
  },
  label: {
    padding: 0,
    textAlign: "left",
  },
  error: {
    borderLeft: "7px solid #fe8368",
  },
};

const GIZPhoneField = ({
  classes,
  name,
  label,
  validator = null,
  disabled = false,
  className,
}) => {
  return (
    <Field name={name} validate={validator}>
      {({ input, meta }) => {
        const { value, onChange, onBlur, onFocus } = input;
        return (
          <div className={classNames(classes.root, className)}>
            <InputLabel className={classes.label}>{label}</InputLabel>
            <NumberFormat
              customInput={TextField}
              variant="outlined"
              format="+38##########"
              mask="_"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              onFocus={onFocus}
              inputProps={{
                className: classNames({
                  [classes.error]:
                    meta.invalid &&
                    (meta.touched || (meta.visited && meta.dirty)),
                }),
              }}
            />
          </div>
        );
      }}
    </Field>
  );
};

export default withStyles(styles)(GIZPhoneField);
